export default {
      id: "action-icon-missing-order-number-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-missing-order-number",
      toString: function () {
        return this.url;
      }
    }